import {
  ContratadosCreateForm,
  ContratadosEditForm,
  Contratados,
  ContratadosTrash
} from "./contratados"
import {
  UnidadesEditForm,
  UnidadesCreateForm,
  UnidadesOrcamentarias,
  UnidadesOrcamentariasTrash
} from "./unidades-orcamentarias"
import {
  Distratos,
  DistratosCreateForm,
  DistratosEditForm,
  TableDistratos,
  DistratosDigitalizados,
  DistratosDigitalizadosCreateForm,
  DistratosDigitalizadosTrash
} from "./distratos"
import {
  GestoresEditForm,
  GestoresCreateForm,
  Gestores,
  GestoresTrash
} from "./gestores"
import {
  FiscaisEditForm,
  FiscaisCreateForm,
  Fiscais,
  FiscaisTrash
} from "./fiscais"
import {
  Contratos,
  ContratosTrash,
  ContratosManageForm,
  ContratosCreateForm,
  ContratosEditForm,
  Digitalizados,
  DigitalizadosCreateForm,
  DigitalizadosTrash,
  Aditivos,
  AditivosCreateForm,
  AditivosEditForm,
  AditivosTrash
} from "./contratos"
import {
  Usuarios,
  UsuariosManageForm,
  UsuariosCreateForm,
  UsuariosEditForm,
  UsuariosTrash
} from "./usuarios"
import {
  Fiscalizacao,
  AtaReuniao,
  AtaReuniaoTrash,
  AtaReuniaoEditForm,
  AtaReuniaoCreateForm,
  DiarioOcorrencias,
  DiarioOcorrenciasCreateForm,
  DiarioOcorrenciasEditForm,
  DiarioOcorrenciasTrash,
  ProrrogacaoContratual,
  ProrrogacaoContratualCreateForm,
  ProrrogacaoContratualEditForm,
  ProrrogacaoContratualTrash,
  Notificacao,
  NotificacaoCreateForm,
  NotificacaoEditForm,
  NotificacaoTrash,
  TermoCircunstanciado,
  TermoCircunstanciadoCreateForm,
  TermoCircunstanciadoEditForm,
  TermoCircunstanciadoTrash
} from "./fiscalizacao"
import { NotasFiscais, NotasFiscaisEditForm, NotasFiscaisTrash } from "./baixas"
import Dashboard from "./Dashboard"
import PersonalizarRelatorios from "./PersonalizarRelatorios"
import { Relatorios } from "./relatorios"
import { Documentos } from "./documentos"
import { LoginForm, Logout } from "./auth"
import ImportacaoTCE from "./ImportacaoTCE"
import RelatorioLogs from "./RelatorioLogs"
import ReciboDeAtestoDeServicoForm from "./ReciboDeAtestoDeServicoForm"
import RelatorioRecibos from "./RelatorioRecibos"

export {
  ContratadosCreateForm,
  ContratadosEditForm,
  Contratados,
  ContratadosTrash,
  UnidadesEditForm,
  UnidadesCreateForm,
  UnidadesOrcamentarias,
  UnidadesOrcamentariasTrash,
  GestoresEditForm,
  GestoresCreateForm,
  Gestores,
  GestoresTrash,
  FiscaisEditForm,
  FiscaisCreateForm,
  Fiscais,
  FiscaisTrash,
  Contratos,
  ContratosTrash,
  ContratosManageForm,
  ContratosCreateForm,
  ContratosEditForm,
  Fiscalizacao,
  AtaReuniao,
  AtaReuniaoTrash,
  AtaReuniaoEditForm,
  AtaReuniaoCreateForm,
  DiarioOcorrencias,
  DiarioOcorrenciasCreateForm,
  DiarioOcorrenciasEditForm,
  DiarioOcorrenciasTrash,
  ProrrogacaoContratual,
  ProrrogacaoContratualCreateForm,
  ProrrogacaoContratualEditForm,
  ProrrogacaoContratualTrash,
  Notificacao,
  NotificacaoCreateForm,
  NotificacaoEditForm,
  NotificacaoTrash,
  TermoCircunstanciado,
  TermoCircunstanciadoCreateForm,
  TermoCircunstanciadoEditForm,
  TermoCircunstanciadoTrash,
  NotasFiscais,
  NotasFiscaisEditForm,
  NotasFiscaisTrash,
  Dashboard,
  Relatorios,
  LoginForm,
  Logout,
  PersonalizarRelatorios,
  Usuarios,
  UsuariosManageForm,
  UsuariosCreateForm,
  UsuariosEditForm,
  UsuariosTrash,
  Digitalizados,
  DigitalizadosCreateForm,
  DigitalizadosTrash,
  Aditivos,
  AditivosCreateForm,
  AditivosEditForm,
  AditivosTrash,
  ImportacaoTCE,
  RelatorioLogs,
  ReciboDeAtestoDeServicoForm,
  Distratos,
  DistratosCreateForm,
  DistratosEditForm,
  TableDistratos,
  RelatorioRecibos,
  Documentos,
  DistratosDigitalizados,
  DistratosDigitalizadosCreateForm,
  DistratosDigitalizadosTrash
}



// WEBPACK FOOTER //
// ./src/views/index.js